import {
  SCORING_API_ENDPOINTS,
  getApiAuthCredentials,
  createApiHeaders,
  createApiFetchOptions,
  createScoringApiUrl,
} from "../services/apiConfig";
import logger from "../../logger";

/**
 * Fetch all available rubrics for the organization.
 * GET /rubrics?archivedOnly=false
 */
export const fetchRubrics = async () => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createScoringApiUrl(SCORING_API_ENDPOINTS.RUBRICS, {
      archivedOnly: false,
    });
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const data = await response.json();

    if (!data) {
      throw new Error("No data returned from API");
    }

    let rubricsArray = [];
    if (Array.isArray(data)) {
      rubricsArray = data;
    } else if (data.data && Array.isArray(data.data)) {
      rubricsArray = data.data;
    } else if (data && typeof data === "object") {
      rubricsArray = [data];
    }

    return rubricsArray;
  } catch (error) {
    logger.error("Error fetching rubrics:", error);
    throw error;
  }
};

/**
 * Fetch scorecards for a given rubric.
 * GET /scorecards?rubricIds[0]=<uuid>
 */
export const fetchScorecardsByRubric = async (rubricId) => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createScoringApiUrl(SCORING_API_ENDPOINTS.SCORECARDS, {
      rubricIds: [rubricId],
    });
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const result = await response.json();

    if (!result) {
      throw new Error("No data returned from API");
    }

    // The response shape is { data: { calculations, scorecards[] } }
    let scorecards = [];
    let calculations = null;

    if (result.data) {
      if (Array.isArray(result.data.scorecards)) {
        scorecards = result.data.scorecards;
      }
      if (result.data.calculations) {
        calculations = result.data.calculations;
      }
    } else if (Array.isArray(result.scorecards)) {
      scorecards = result.scorecards;
    } else if (Array.isArray(result)) {
      scorecards = result;
    }

    return { scorecards, calculations };
  } catch (error) {
    logger.error("Error fetching scorecards:", error);
    throw error;
  }
};
